import { Text } from '@latitude/text';
import { Tooltip } from '@latitude/tooltip';
import type { PortoSignupFormPage } from 'components/porto/Signup/types';
import { useMemo } from 'react';

import { PORTO_SIGNUP_FORM_PAGES } from '../../../constants';

type Props = {
  page: PortoSignupFormPage;
};

function FormHeader({ page }: Props) {
  const { description, step, title } = useMemo(() => {
    switch (page) {
      case PORTO_SIGNUP_FORM_PAGES.COMPLETE_YOUR_PROFILE:
        return {
          description:
            'Start by entering a few personal details. Failure to provide legitimate information may cause disruptions to the account.',
          step: 1,
          title: 'Complete your profile',
        };
      case PORTO_SIGNUP_FORM_PAGES.ORGANIZATION_DETAILS:
        return {
          description: "Now, fill in your organization's information.",
          step: 2,
          title: 'Organization details',
        };
    }
  }, [page]);

  return (
    <div className="flex flex-col gap-0 sm:gap-2">
      <Text>Step {step} of 2</Text>
      <Text variant="metricHuge" className="hidden sm:block">
        {title}
      </Text>
      <Text variant="headingMedium" className="block sm:hidden">
        {title}
      </Text>
      <Text variant="labelMedium">
        {description}
        <Tooltip
          wrapperClassName="inline"
          className="text-clip"
          side="bottom"
          text={
            <div className="flex flex-col items-start gap-3">
              <Text variant="labelMedium" className="text-start">
                We collect this information to comply with relevant laws and
                regulations. We only use it for business purposes and do not
                share it for any other reason. Failure to provide legitimate
                information may cause disruptions to the account.
              </Text>
            </div>
          }
        >
          <Text
            asChild
            variant="labelMedium"
            className="pl-1 text-color-ref-text-link-primary"
            data-testid="tooltip-text"
          >
            <span>Why is this important?</span>
          </Text>
        </Tooltip>
      </Text>
    </div>
  );
}

export default FormHeader;
